import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LOCATIONS_FEATURE_KEY, selectAllLocations, selectLocationsEntities } from './location.reducer';
import { LocationsState } from './location.state';

const selectState = createFeatureSelector<LocationsState>(LOCATIONS_FEATURE_KEY);

const isFetching = createSelector(selectState, (state) => state.isFetching);
const isFetchingPaginated = createSelector(selectState, (state) => state.isFetchingPaginated);
const isProcessing = createSelector(selectState, (state) => state.isProcessing);

const location = createSelector(selectState, (state) => state.location);
const all = createSelector(selectState, selectAllLocations);
const entities = createSelector(selectState, selectLocationsEntities);
const queryParams = createSelector(selectState, (state: LocationsState) => state.queryParams);
const paginatedData = createSelector(selectState, (state: LocationsState) => state.paginatedData);

export const LocationsSelectors = {
  isFetching,
  isFetchingPaginated,
  isProcessing,
  location,
  all,
  entities,
  queryParams,
  paginatedData,
};
